import { getCurrentInstance } from "vue";
import { type RouteLocationMatched, useRoute } from "vue-router";

/** Finds the route that's actually responsible for rendering this component */
export const findCurrentRoute = ():
  | (RouteLocationMatched & { name: string })
  | null => {
  const route = useRoute();
  let instance = getCurrentInstance();

  while (instance) {
    const match = route.matched.find(({ components }) => {
      if (!components) return false;
      return components.default === instance!.type;
    });

    if (match) {
      if (typeof match.name !== "string") {
        return null;
      }

      return match as RouteLocationMatched & { name: string };
    }

    instance = instance.parent;
  }

  return null;
};
